import { onTTFB } from "../../../utils/web-vitals";
import { sendAsyncMetric } from '.';
import { fix } from "../../utils";
export var startTTFB = function startTTFB(task) {
  return new Promise(function (resolve) {
    onTTFB(function (entry) {
      var ttfb = fix(entry.value);
      // console.log('ttfb', entry, ttfb)
      sendAsyncMetric(task, {
        type: 'ttfb',
        value: ttfb
      });
      resolve({
        ttfb: ttfb
      });
    });
  });
};